import React from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

const ListRowDropdown = ({ menuState, toggle, dropdownItems }) => {
    return <React.Fragment>
        <div className="col-auto px-1 actions d-sm-flex">
            <Dropdown
                isOpen={menuState}
                toggle={toggle}>
                <DropdownToggle tag="span">
                    <span className="icon-btn text-grey pointer">
                        <i className="zmdi zmdi-more-vert zmdi-hc-lg" />
                    </span>
                </DropdownToggle>
                <DropdownMenu>
                    {dropdownItems}
                </DropdownMenu>
            </Dropdown>
        </div>
    </React.Fragment>;
};

export default ListRowDropdown;


// WEBPACK FOOTER //
// ./components/ListRowDropdown/index.js